import DiscountVoucherSlideUpModal from "./index";

export function MultipleDiscountVoucherSlideUpModalExamples() {
  const discountVouchers: any[] = [
    {
      id: "8eb4d784-7652-468c-a60a-564b299853a4",
      serviceOfferingType: "CONSULTATIONS",
      usageStatus: "ACTIVE",
      availableFrom: "2025-08-01T13:39:09.698343+00:00",
      availableTo: "2028-08-01T13:39:01.741795+00:00",
      name: "Online Doctor Consultation",
      description: "Virtual consultations with qualified medical doctors",
      chargeCode: "ONLINE_DOCTOR_CONSULTATION",
      offeringId: "4f24e185-2534-47e9-ac67-95b179c5f4cf",
      linkedBenefitType: "Product",
      linkedBenefitName: "Unu As-You-Go",
      document: null,
      voucherDetails: null,
      discountVoucherDetails: {
        voucherId: "a2569085-574b-4a30-a0aa-a7df483ed20d",
        voucherCode: "ZPBN-8458-HMMJ",
        expiryDate: "2028-08-01T13:29:32+00:00",
        discountAmount: 4900,
        amount: 20000,
        originalAmount: 24900,
        currencyCode: "ZAR",
      },
    },
    {
      id: "8eb4d784-7652-468c-a60a-564b299853a4",
      serviceOfferingType: "CONSULTATIONS",
      usageStatus: "ACTIVE",
      availableFrom: "2025-08-01T13:39:09.698343+00:00",
      availableTo: "2028-08-01T13:39:01.741795+00:00",
      name: "Online Doctor Consultation",
      description: "Virtual consultations with qualified medical doctors",
      chargeCode: "ONLINE_DOCTOR_CONSULTATION",
      offeringId: "4f24e185-2534-47e9-ac67-95b179c5f4cf",
      linkedBenefitType: "Product",
      linkedBenefitName: "Unu As-You-Go",
      document: null,
      voucherDetails: null,
      discountVoucherDetails: {
        voucherId: "a2569085-574b-4a30-a0aa-a7df483ed20d",
        voucherCode: "ZPBN-8458-HMMJ",
        expiryDate: "2028-08-01T13:29:32+00:00",
        discountAmount: 2900,
        amount: 10000,
        originalAmount: 12900,
        currencyCode: "ZAR",
      },
    },
  ];

  return (
    <DiscountVoucherSlideUpModal
      isModalOpen={true}
      onModalClose={() => console.log("close")}
      onContinueButtonClick={() => console.log("continue")}
      discountVouchers={discountVouchers}
    />
  );
}

export function SingleDiscountVoucherSlideUpModalExamples() {
  const discountVouchers: any[] = [
    {
      id: "8eb4d784-7652-468c-a60a-564b299853a4",
      serviceOfferingType: "CONSULTATIONS",
      usageStatus: "ACTIVE",
      availableFrom: "2025-08-01T13:39:09.698343+00:00",
      availableTo: "2028-08-01T13:39:01.741795+00:00",
      name: "Online Doctor Consultation",
      description: "Virtual consultations with qualified medical doctors",
      chargeCode: "ONLINE_DOCTOR_CONSULTATION",
      offeringId: "4f24e185-2534-47e9-ac67-95b179c5f4cf",
      linkedBenefitType: "Product",
      linkedBenefitName: "Unu As-You-Go",
      document: null,
      voucherDetails: null,
      discountVoucherDetails: {
        voucherId: "a2569085-574b-4a30-a0aa-a7df483ed20d",
        voucherCode: "ZPBN-8458-HMMJ",
        expiryDate: "2028-08-01T13:29:32+00:00",
        discountAmount: 2900,
        amount: 10000,
        originalAmount: 12900,
        currencyCode: "ZAR",
      },
    },
  ];

  return (
    <DiscountVoucherSlideUpModal
      isModalOpen={true}
      onModalClose={() => console.log("close")}
      onContinueButtonClick={() => console.log("continue")}
      discountVouchers={discountVouchers}
    />
  );
}
